import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59708cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "labo row align-items-center" }
const _hoisted_4 = { class: "col item-title" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "distributor row align-items-center" }
const _hoisted_7 = { class: "col item-title" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "trademark row align-items-center" }
const _hoisted_10 = { class: "col item-title" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-5 border-bottom border-light mt-4 mb-3" }, "iPrins", -1))
const _hoisted_13 = { class: "data-provider row align-items-center mb-3" }
const _hoisted_14 = { class: "col item-title" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "apb-code row align-items-center" }
const _hoisted_17 = { class: "col item-title" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "registration-nr row align-items-center mb-3" }
const _hoisted_20 = { class: "col item-title" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "name-nl row align-items-center" }
const _hoisted_23 = { class: "col item-title" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "address-nl row align-items-start mb-3" }
const _hoisted_26 = { class: "col item-title" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "name-fr row align-items-center" }
const _hoisted_30 = { class: "col item-title" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "address-fr row align-items-start mb-3" }
const _hoisted_33 = { class: "col item-title" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "phone row align-items-center" }
const _hoisted_37 = { class: "col item-title" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "fax row align-items-center" }
const _hoisted_40 = { class: "col item-title" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "email row align-items-center" }
const _hoisted_43 = { class: "col item-title" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "website row align-items-center" }
const _hoisted_46 = { class: "col item-title" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = ["href"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fs-5 ms-2" }, "open_in_new", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AlertError2, {
      error: _ctx.iPrinsLaboUI.getError(),
      class: "mb-3"
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.iPrinsLaboUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.iPrinsLaboUI.isReady())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('brand')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.product.producent_detail_info?.labo?.description), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('distributor')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.product.producent_detail_info?.distributor?.description), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('trademark')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.product.producent_detail_info?.trademark?.description), 1)
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('source')), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.iPrinsLabo?.data_provider_code), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('apbCode')), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"])),
                class: "cu-p"
              }, _toDisplayString(_ctx.iPrinsLabo.apb_code), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('registrationNumber')), 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"])),
                class: "cu-p"
              }, _toDisplayString(_ctx.iPrinsLabo?.registration_nr), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('nameDutch')), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.iPrinsLabo.name_nl), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('addressDutch')), 1),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                innerHTML: _ctx.getMultilingualAddress(_ctx.iPrinsLabo.address_nl, _ctx.iPrinsLabo.municipality_nl),
                class: "cu-p",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"]))
              }, null, 8, _hoisted_28)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('nameFrench')), 1),
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.iPrinsLabo.name_fr), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('addressFrench')), 1),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", {
                innerHTML: _ctx.getMultilingualAddress(_ctx.iPrinsLabo.address_fr, _ctx.iPrinsLabo.municipality_fr),
                class: "cu-p",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"]))
              }, null, 8, _hoisted_35)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('telephone')), 1),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"])),
                class: "cu-p"
              }, _toDisplayString(_ctx.iPrinsLabo?.phone_nr), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('fax')), 1),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("span", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"])),
                class: "cu-p"
              }, _toDisplayString(_ctx.iPrinsLabo?.fax_nr), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('emailAddress')), 1),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("span", {
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"])),
                class: "cu-p"
              }, _toDisplayString(_ctx.iPrinsLabo?.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('website')), 1),
            _createElementVNode("div", _hoisted_47, [
              (_ctx.iPrinsLabo.website)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.iPrinsLabo.website,
                    target: "_blank",
                    class: "d-flex align-items-center text-decoration-none"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.iPrinsLabo?.website), 1),
                    _hoisted_49
                  ], 8, _hoisted_48))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}